<template>
  <section class="my-10">
    <div class="mx-10 mt-10">
      <TableList :items="tokens" class="space-y-8" :columns="10">
        <template #columns>
          <div class="grid w-full grid-cols-10 font-semibold font-poppins">
            <span class="col-span-2">Name</span>
            <span class="col-span-3">Id</span>
            <span class="col-span-2">Scopes</span>
            <span class="col-span-2">Expires At</span>
            <span class="justify-self-end">Actions</span>
          </div>
        </template>
        <template #row="{ item }">
          <span class="col-span-2 text-gray-600 font-openSans">
            {{ item.name }}
          </span>
          <span class="col-span-3 text-gray-600 font-openSans">
            {{ item.id }}
          </span>
          <span class="col-span-2 text-gray-600 font-openSans">
            {{ item.scopes }}
          </span>
          <span class="col-span-2 text-gray-600 font-openSans">
            {{ item.expiresAt || 'Never' }}
          </span>
          <div class="flex gap-x-4 justify-self-end">
            <button @click="deleteToken(item)">
              <delete-icon
                class="inline-block w-6 h-6 text-gray-600 transition-all duration-300 ease-out opacity-25 cursor-default"
                :class="{
                  'opacity-100 hover:text-yellow-500 cursor-pointer':
                    item.id !== user.id && item.roleId !== 1,
                }"
              />
            </button>
          </div>
        </template>
      </TableList>
    </div>
  </section>
  <hr class="text-gray-100" />
  <section class="my-10">
    <h2 class="text-2xl font-normal font-poppins">Add Token</h2>
    <div class="mt-10 ml-10">
      <AddAuthTokenForm @success="fetch" />
    </div>
  </section>
  <ConfirmModal id="delete-api-token" title="Delete API Token" />
</template>

<script>
import TableList from '@/components/lists/TableList.vue';
import AddAuthTokenForm from '@/components/forms/AddAuthTokenForm.vue';
import { useStore } from 'vuex';
import { onMounted } from 'vue';
import { useState, useModal, useToast } from '@/helpers/composables';

export default {
  components: {
    TableList,
    AddAuthTokenForm,
  },
  setup() {
    const store = useStore();
    const user = store.state.user.user;
    const [tokens, setTokens] = useState([]);
    const { open: openDeleteUserModal } = useModal('delete-api-token');
    const toast = useToast();

    onMounted(() => {
      fetch();
    });

    async function fetch() {
      const { data } = await store.dispatch('get', { action: '/tokens' });
      setTokens(data);
    }

    function deleteToken({ id }) {
      openDeleteUserModal({
        body: `Are you sure you want to delete this token from the system?`,
        confirm: {
          text: 'Yes, Delete',
          action: async ({ close }) => {
            const { message } = await store.dispatch('delete', {
              action: '/tokens',
              param: id,
            });
            toast.show(message);
            close();
            fetch();
          },
        },
      });
    }

    return {
      user,
      tokens,
      deleteToken,
      fetch,
    };
  },
};
</script>
